import { AppConfigurationService } from './app-configuration.service';
import { routes } from './app.routes';
import {
  ApplicationConfig,
  importProvidersFrom,
  inject,
  provideAppInitializer,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  provideHttpClient,
  HTTP_INTERCEPTORS,
  withInterceptorsFromDi,
  HttpClient,
  withInterceptors,
  withFetch,
} from '@angular/common/http';
import { SpinnerInterceptor } from './core/interceptors/spinner/spinner.interceptor';
import { SpinnerService } from './core/shared/services/spinner.service';
import { MsalBroadcastService, MsalGuard, MsalService } from '@azure/msal-angular';
import { provideMSAL } from './core/auth/msal.config';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import { InjectionToken } from '@angular/core';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { provideAnimations } from '@angular/platform-browser/animations';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslationInterceptor } from './core/interceptors/translation-interceptor.interceptor';
import { environment } from '../environments/environment';
import { apiKeyInterceptor } from './core/interceptors/api-key.interceptor';
import { SetNameDisplayPipe } from './core/shared/pipes/set-name-display.pipe';
import { abortSignalInterceptor } from './core/interceptors/abort-signal.interceptor';
import { DSModule } from '@idb/designsystem';

export const API_URL = new InjectionToken<string>('apiUrl', {
  providedIn: 'root',
  factory: () => environment.apiUrl,
});

const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) =>
  new TranslateHttpLoader(http, './assets/i18n/', '.json');
export const appConfig: ApplicationConfig = {
  providers: [
    SetNameDisplayPipe,
    AppConfigurationService,
    provideAppInitializer(() => {
      return inject(AppConfigurationService).loadConfigurations();
    }),
    provideAnimations(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    SpinnerService,
    MsalService,
    MsalBroadcastService,
    MsalGuard,
    provideHttpClient(
      withFetch(),
      withInterceptorsFromDi(),
      withInterceptors([abortSignalInterceptor, apiKeyInterceptor]),
    ),
    { provide: HTTP_INTERCEPTORS, useClass: SpinnerInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: TranslationInterceptor, multi: true },
    importProvidersFrom([
      TranslateModule.forRoot({
        loader: {
          provide: TranslateLoader,
          useFactory: httpLoaderFactory,
          deps: [HttpClient],
        },
      }),
    ]),
    provideMSAL(),
    importProvidersFrom(MatSnackBarModule, DSModule),
  ],
};
